/**
 * 删除非顶部子菜单
 * @param children
 */
function deleteSchChildren(children) {
    if (children) {
        for (let i = children.length - 1; i >= 0; i--) {
            if (children[i].is_school == 1) {
                delete children[i]
            } else {
                deleteSchChildren(children[i].Children)
            }
        }
    }
}

/**
 * 去掉子菜单中数组为空的部分
 * @param children
 * @returns {*}
 */
function filterSchChildren(children) {
    if (children) {
        let result = children.filter(function(val) {
            return val
        })
        for (let i = 0; i < result.length; i++) {
            if (result[i].Children) {
                result[i].Children = filterSchChildren(result[i].Children)
            }
        }
        return result
    }
    return null
}

const permission = {
    state: {
        menus: null, //菜单及操作权限
        schools: null, //学校权限
        currentSchool: null, //当前学校
        currentRoleGroup: null,
        currentOrganizationId: null,
        currentOrganizationName: null
    },
    mutations: {
        SET_PERMISSIONS: (state, permissions) => {
            state.menus = permissions.menus
            state.schools = permissions.schools
            state.currentSchool = permissions.currentSchool
            state.currentRoleGroup = permissions.currentRoleGroup
            state.currentOrganizationId = permissions.currentOrganizationId
            state.currentOrganizationName = permissions.currentOrganizationName
        },
        // updataSchooName: (state, name) => {
        //     state.currentSchool.school_name = name
        // }
        SET_CURRENTSCHOOL: (state, school) => {
            state.currentSchool = school
        },
        SET_ORGANIZATION: (state, info) => {
            state.currentRoleGroup = info.currentRoleGroup
            state.currentOrganizationId = info.currentOrganizationId
            state.currentOrganizationName = info.currentOrganizationName
        }
    },
    actions: {
        /**
         * 生成权限数据
         * @param commit
         * @param data
         * @constructor
         */
        GeneratePermisions({ commit }, data) {
            //过滤学校权限菜单
            if (data.currentRoleGroup != 3) {
                if (data.menus != null && data.menus.length > 0) {
                    for (let i = data.menus.length - 1; i >= 0; i--) {
                        if (data.menus[i].is_school == 1) {
                            delete data.menus[i]
                        } else {
                            deleteSchChildren(data.menus[i].Children)
                        }
                    }
                    //去掉数组为空的部分
                    data.menus = filterSchChildren(data.menus)
                }
            }
            commit('SET_PERMISSIONS', data)
        }
    }
}

export default permission


// WEBPACK FOOTER //
// ./src/store/modules/permission.js